module.exports = "/fonts/TT_Norms_Pro_Bold.ttf";